import {
    OatEditorPage, Telemetry, TelemetryService, TelemetryTypes
} from '@microsoft/iot-cardboard-js';
import { useThemeContext } from '../../Theming/ThemeProvider';
import { useLanguageContext } from '../../Models/Context/I18nProvider';
import { useCallback, useEffect } from 'react';
import { LOCAL_STORAGE_KEYS } from '../../Models/Constants/Constants';
import appInsightsInstance from '../../Services/AppInsightsService';
import { convertSeverityToAppInsightsSeverity } from '../../Services/Utils';

const OntologyDesigner = () => {
    const { selectedTheme } = useThemeContext();
    const { selectedLang } = useLanguageContext();

    const telemetryCallback = useCallback(
        async (telemetry: Telemetry.TelemetryItem) => {
            if (
                localStorage.getItem(
                    LOCAL_STORAGE_KEYS.FeatureFlags.Telemetry.debugLogging
                ) === 'true'
            ) {
                console.debug(
                    `[OAT] [Telemetry] ${telemetry.name} ${telemetry.type} emitted`,
                    telemetry
                );
            }
            // Add OAT as source for every telemetry log
            telemetry.customProperties['AppName'] = 'OAT';

            switch (telemetry.type) {
                case TelemetryTypes.TelemetryType.metric:
                    appInsightsInstance.appInsights.trackMetric(
                        {
                            name: telemetry.name,
                            sampleCount: telemetry.sampleSize,
                            average: telemetry.average,
                            min: telemetry.min,
                            max: telemetry.max
                        },
                        telemetry.customProperties
                    );
                    break;
                case TelemetryTypes.TelemetryType.event:
                    appInsightsInstance.appInsights.trackEvent(
                        { name: telemetry.name },
                        telemetry.customProperties
                    );
                    break;
                case TelemetryTypes.TelemetryType.request:
                    break;
                case TelemetryTypes.TelemetryType.exception:
                    appInsightsInstance.appInsights.trackException(
                        {
                            exception: {
                                name: telemetry.name,
                                message: telemetry.message || '',
                                stack: telemetry.stack,
                                columnNumber: -1,
                                error: {},
                                lineNumber: -1,
                                url: ''
                            },
                            id: telemetry.exceptionId,
                            severityLevel: convertSeverityToAppInsightsSeverity(
                                telemetry.severityLevel
                            )
                        },
                        telemetry.customProperties
                    );
                    break;
                case TelemetryTypes.TelemetryType.trace:
                    appInsightsInstance.appInsights.trackTrace(
                        {
                            message: telemetry.message,
                            severityLevel: convertSeverityToAppInsightsSeverity(
                                telemetry.severityLevel
                            )
                        },
                        telemetry.customProperties
                    );
                    break;
                default:
                    console.warn(
                        `Received unexpected telemetry event of type ${
                            (telemetry as any).type
                        }. Ignoring.`
                    );
                    break;
            }
        },
        []
    );
    useEffect(() => {
        TelemetryService.registerTelemetryCallback(telemetryCallback);
    }, [telemetryCallback]);

    return (
        <div style={{ height: '100%', position: 'relative' }}>
            <OatEditorPage selectedThemeName={selectedTheme} locale={selectedLang} />
        </div>
    );
};

export default OntologyDesigner;
